module.exports = __webpack_public_path__ + "static/media/facebook-f.3ca31a0e.svg";